import { useQuery } from '@tanstack/react-query';
import { fetchOrders, type OrdersParams } from '@/lib/api';

export function useOrders(params: OrdersParams = {}) {
  return useQuery({
    queryKey: ['orders', params],
    queryFn: () => fetchOrders(params),
    placeholderData: (prev) => prev,
    staleTime: 10_000,
  });
}
